
import il8n from '@/i18n.js'
import Axios from "axios";

export const lang = {
    state: {
        lang: localStorage.getItem('lang') || 'de',
    },
    getters: {
        lang: state => state.lang
    },
    mutations: {
        SET_LANG (state, payload) {
            let language = payload;
            il8n.locale = language;
            state.lang = language;
            Axios.defaults.headers.common['Accept-Language'] = language
        },
    },
    actions: {
        SET_LANG({commit}, payload) {
            let lang = payload.toLowerCase();
            localStorage.lang = lang;
            commit('SET_LANG', lang)
        }
    }
}